<template>
  <v-toolbar
    dense
    :width="180"
    elevation="1"
    v-if="$route.name !== 'Articulos' && $route.params.scat!=='45'"
  >
    <v-btn
      color="transparent"
      elevation="0"
      class="ma-2 white--text"
      fab
      x-small
      :ripple="false"
      :loading="statusFile.Loading"
      :disabled="statusFile.Loading"
      @click="downloadPdf({ data: filterconsolidado })"
    >
      <IconPdf />
    </v-btn>
    <div class="text-center">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="100"
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            v-bind="attrs"
            v-on="on"
            text
            color="info"
            small
            :disabled="statusFile.Loading"
          >
            Opciones
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-item v-if="dataUser.VerPrecios[tipoMoneda]">
              <v-list-item-action>
                <v-switch
                  :ripple="false"
                  v-model="verprecio"
                  :disabled="statusFile.Loading"
                  color="primary"
                ></v-switch>
              </v-list-item-action>
              <v-list-item-title>Incluir Precio</v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-action>
                <v-switch
                  v-model="solostock"
                  color="primary"
                  :ripple="false"
                ></v-switch>
              </v-list-item-action>
              <v-list-item-title>Con Stock</v-list-item-title>
            </v-list-item>
          </v-list>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn @click="menu = false" text color="info" small> Salir </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { IconPdf } from "../Icons";

export default {
  data() {
    return {
      controller: new AbortController(),
      verprecio: true,
      fav: true,
      menu: false,
      message: false,
      solostock: true,
      statusFile: {
        Loading: false,
        Error: null,
      },
    };
  },
  components: { IconPdf },
  methods: {
    groupBy(objectArray, property) {
      return objectArray.reduce(function (total, obj) {
        let key = obj[property];
        if (!total[key]) {
          total[key] = [];
        }
        total[key].push(obj);

        return total;
      }, {});
    },
    async downloadPdf({ data }) {
      const urlBase = `${this.server}PdfApp/lista.php`;
      const filterDisponible = (items) => {
        const resItems = this.solostock
          ? items.filter((item) => item.Disponible > 0)
          : items;
        return this.groupBy(resItems, "Formato");
      };
      const getNameCategory = () => {
        const item = this.SubCategorias.find((item) => item.SubCategoria !== 0);
        return item ? item.Nombre : undefined;
      };
      
      const params = {
        data: filterDisponible(data),
        verprecio: this.dataUser.VerPrecios[this.tipoMoneda],
        preciocliente: this.dataUser.VerPrecios[this.tipoMoneda]
          ? this.verprecio
          : false,
        constock: this.solostock,
        catname: getNameCategory()
      };
      try {
        this.statusFile = { Loading: true };
        await fetch(urlBase, {
          method: "POST",
          body: JSON.stringify(params),
        })
          .then((resp) => resp.arrayBuffer())
          .then((resp) => {
            const file = new Blob([resp], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = fileURL;
            link.download = `Catalogo.pdf`;
            link.click();
            this.statusFile = { Loading: false };
          });
      } catch (error) {
        this.statusFile = { Loading: false, Error: error };
      }
    },
  },
  computed: {
    ...mapState(["server", "dataUser", "tipoMoneda", "SubCategorias"]),
    ...mapGetters(["filterconsolidado"]),
  },
};
</script>

<style></style>
